const isBrowser = typeof window !== 'undefined';

export const safeLocalStorage = {
	getItem: (key) => {
		if (isBrowser) {
			try {
				const value = window.localStorage.getItem(key);
				return value ? JSON.parse(value) : null;
			} catch (error) {
				console.error(`Error getting item from localStorage: ${error}`);
			}
		}
	},
	setItem: (key, value) => {
		if (isBrowser) {
			try {
				window.localStorage.setItem(key, JSON.stringify(value));
			} catch (error) {
				console.error(`Error setting item to localStorage: ${error}`);
			}
		}
	},
	removeItem: (key) => isBrowser && window.localStorage.removeItem(key),
	clear: () => isBrowser && window.localStorage.clear(),
	clearLocalStorageItems: (items) => {
		items.forEach(item => isBrowser && window.localStorage.removeItem(item));
	},
	clearSessionStorage: () => isBrowser && window.sessionStorage.clear(),
};